export default "__VITE_ASSET__8ddd3d45__"